import CertificationsAnalytics from "./CertificationsAnalytics";

export default CertificationsAnalytics;
